import type {V1ContextInput} from '../../../schema/types';

export default function mergeContextVariables(
  v1Context: V1ContextInput,
  v1Variables: Partial<V1ContextInput> | null | undefined,
): V1ContextInput {
  return {
    accountId: v1Variables?.accountId ?? v1Context.accountId,
    apiKey: v1Variables?.apiKey ?? v1Context.apiKey,
    betaHeaders: v1Variables?.betaHeaders ?? v1Context?.betaHeaders,
    liveMode: v1Variables?.liveMode ?? v1Context.liveMode,
    id: v1Variables?.id ?? v1Context.id,
  };
}
